var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProdukty = function SvgProdukty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12,16.6c-0.5,0-0.9,0.4-0.9,0.9v2.8c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-2.8C12.9,17,12.5,16.6,12,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16,16.6c-0.5,0-0.9,0.4-0.9,0.9v2.8c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-2.8 C16.9,17,16.5,16.6,16,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M24,3.7c0-0.5-0.4-0.9-0.9-0.9c-2.2,0-4.2,1.1-5.4,3c-0.5-0.1-1-0.2-1.5-0.2c-0.7,0-1.3,0.1-1.9,0.4V2.3 C14.3,1,13.3,0,12,0S9.8,1,9.8,2.3v5.5L9,6.6C8.5,5.8,7.7,5.2,6.7,5.1L5.8,2.8C5.5,1.9,4.7,1.4,3.7,1.4c-0.5,0-1,0.2-1.4,0.5L0.9,3 C0.3,3.5,0,4.1,0,4.8c0,0.7,0.3,1.4,0.9,1.8l2,1.4C2.8,9,3.1,10,3.8,10.6c0,0,0.5,0.5,0.5,0.5H2.3c-1.2,0-2.3,1-2.3,2.3 c0,0.9,0.6,1.8,1.5,2.1l1.1,6.6C2.8,23.2,3.8,24,4.9,24h14.3c1.1,0,2.1-0.8,2.2-1.9l1.1-6.6c0.9-0.3,1.5-1.2,1.5-2.1 c0-0.8-0.4-1.5-1.1-1.9c0.7-1.1,1.1-2.3,1.1-3.6V3.7z M19.2,22.2H4.9c-0.2,0-0.4-0.2-0.5-0.4l-1-6.1h17.3l-1,6.1 C19.6,22,19.4,22.2,19.2,22.2z M2,4.4L2,4.4l1.5,1.9L2,5.2C1.8,5.1,1.8,5,1.8,4.8C1.8,4.7,1.8,4.5,2,4.4z M9.7,11.1H6.8l-1-1 l1.1-0.9c0.2-0.1,0.3-0.4,0.3-0.6c0-0.2,0-0.5-0.2-0.7C6.9,7.8,6.7,7.7,6.4,7.7C6.2,7.7,6,7.8,5.8,7.9L4.7,8.8 c-0.2-0.6,0-1.3,0.5-1.7c0.3-0.2,0.6-0.3,0.9-0.3c0.6,0,1.1,0.3,1.3,0.8L9.7,11.1z M3.4,3.3c0.1-0.1,0.2-0.1,0.3-0.1 c0.2,0,0.4,0.1,0.5,0.3l0.7,1.8L3.4,3.3L3.4,3.3z M12,1.8c0.3,0,0.5,0.2,0.5,0.5v8.8h-1V2.3C11.5,2,11.8,1.8,12,1.8z M21.7,13.9 H2.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h19.4c0.3,0,0.5,0.2,0.5,0.5C22.2,13.7,22,13.9,21.7,13.9z M22.2,4.7v3.2 c0,1-0.4,2-1,2.9c0,0,0-0.1,0-0.1c0-1.6-0.7-3-2-4C20,5.6,21,4.9,22.2,4.7z M16.2,7.4c1.8,0,3.3,1.5,3.3,3.3c0,0.2,0,0.3,0,0.5 h-5.1V8C14.8,7.6,15.5,7.4,16.2,7.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.2,
    cy: 9.2,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M8.1,16.6c-0.5,0-0.9,0.4-0.9,0.9v2.8c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-2.8C8.9,17,8.5,16.6,8.1,16.6z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProdukty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/produkty.5ed6f0c5.svg";
export { ForwardRef as ReactComponent };